import { useId } from "react";

import starkBanner from "@/assets/leaderboard/houses/stark-banner.webp";

export const WinterfellBanner = ({ x, y }: { x: number; y: number }) => {
  /* React Hooks */
  const clipId = useId();

  /* Render */
  const render = () => (
    <g transform={`translate(${x} ${y})`}>
      <defs>
        <clipPath id={clipId}>
          <path d="M-20 0H20V70L0 84-20 70Z" />
        </clipPath>
      </defs>
      <path d="M-22 4H22V74L2 88-22 74Z" fill="#10202d" opacity="0.3" />
      <image
        href={starkBanner}
        x="-20"
        y="0"
        width="40"
        height="84"
        preserveAspectRatio="xMaxYMin slice"
        clipPath={`url(#${clipId})`}
      />
      <path
        d="M-20 0H20V70L0 84-20 70Z"
        fill="none"
        stroke="#9aadb7"
        strokeWidth="1"
      />
      <path
        d="M-25-3H25"
        stroke="#293b49"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path d="M-14-2V5M14-2V5" stroke="#c8d1d5" strokeWidth="2" />
    </g>
  );

  return render();
};
